import React, { PureComponent } from 'react'
import { Button, Icon, Upload, Modal, Form } from 'antd'
import moment from 'moment'
import { actionClearMessage } from '../../../redux-flow/actions/contratos'
import { maskCpf, maskTelefone, maskCnpj } from '../../../utils/masks'
import { API_URL, getInfoLocalStorage } from '../../../utils/api';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import attach from '../../../images/attach.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import FormResetPassword from '../FormResetPassword'
import SideBar from '../../../Components/SideBar';
import profile from '../../../images/profile.png'
import { infoRequired, validateCaracteresUpload } from '../../../utils/validators'

const { Dragger } = Upload;

class CardUserWrapper extends PureComponent {
    constructor(props) {
        super(props)
        // Ensure props.user exists to avoid errors
        const user = props.user || {};
        this.state = {
            documentoAlt: !!(user.documento),
            comprovanteAlt: !!(user.comprovanteEndereco),
            fotoPerfil: !!(user.fotoPerfil),
            documentoFile: null,
            documento: String(user.documento || '').replace(/[\s\S]*\/([^/]+)$/, '$1') || null,
            comprovanteEndereco: String(user.comprovanteEndereco || '').replace(/[\s\S]*\/([^/]+)$/, '$1') || null,
            comprovanteFile: null,
            fotoPerfilFile: null,
            statusUploadRG: null,
            statusUploadResidencia: null,
            statusUploadPerfil: null,
            nivelVerificacao: user.nivelVerificacao || '',
            error: {},
            message: '',
            isClicked: 0,
            modalOpenDocModal: false,
            modalOpenComprovante: false
        }
    }

    openModalIdentificacao = () => {
        this.setState({
            modalOpenDocModal: true
        })
    }

    openModalDocEndereco = () => {
        this.setState({
            modalOpenComprovante: true
        })
    }

    openModalSenha = () => {
        this.setState({
            modalSenhaOpened: true
        })
    }
    closeModalSenha = () => {
        this.setState({
            modalSenhaOpened: false
        })
    }

    closeModalIdentificacao = () => {
        this.setState({ modalOpenDocModal: false })
        actionClearMessage()
    }

    closeModalComprovante = () => {
        this.setState({ modalOpenComprovante: false })
        actionClearMessage()
    }

    uploadFile = async (referer, file, type) => {
        if(file !== null) {
            this.setState({ [referer]: 'loading' })
            try {
                const { user: { id: userid } } = this.props
                if (userid | 0) {
                    const formData = new FormData()
                    formData.append('id', userid)
                    formData.append('file', file)
                    formData.append('type', type)
                    const response = await fetch(API_URL + 'upload', {
                        method: 'POST',
                        body: formData,
                        headers: {
                            'Authorization': `Bearer ${getInfoLocalStorage().token}`
                        }
                    })
                    const { code } = await response.json()
                    if (code === 11) {
                        this.uploadSuccess(referer)
                    } else {
                        this.uploadError(referer)
                    }
                } else {
                    this.uploadError(referer)
                }
            } catch (e) {
                this.uploadError(referer)
            }
        }
    }

    uploadLoading = (referer, type, file) => {
        const ref = type === 1 ? 'documento' : (type === 2 ? 'comprovanteEndereco' : 'fotoPerfil')
        this.setState({
            [ref]: file.name
        })

    }

    uploadSuccess = referer => {
        if (referer === 'statusUploadPerfil') {
            this.interval = setTimeout(() => {
                this.setState({
                    [referer]: 'done',
                    fotoPerfil: true
                })
                window.location.reload()
            }, 1000)
        } else {
            this.setState({
                [referer]: 'done',
                [referer === 'statusUploadRG' ? 'documentoAlt' : 'comprovanteAlt']: true
            })
        }
    }

    uploadError = referer => {
        this.setState({
            [referer]: 'error'
        })
    }

    beforeUpload = (referer, type) => file => {
        const specialChars = /^[a-zA-Z0-9_-\d ]+$/
        const fileWithoutExtension = file.name.split('.').slice(0, -1).join()
        const acceptedFormats = ['jpeg', 'jpg', 'pdf', 'png']
        const fileSize = file.size
        if (specialChars.test(fileWithoutExtension) === false) {
            this.setState({ error: { type: 'specialChars', message: 'O nome do arquivo não pode conter caracteres especiais e acentos.' }, isClicked: type })
        } else if (acceptedFormats.includes(file.name.split('.')[1]) === false) {
            this.setState({ error: { type: 'typeOfFile', message: 'Por favor, envie arquivos nos formatos jpg, jpeg, pdf ou png.' }, isClicked: type })
        } else if (fileSize > 5242880) { // 5MB in bytes
            this.setState({ error: { type: 'fileSize', message: 'Por favor, envie arquivos de até 5MB.' }, isClicked: type})               
        } else {
            this.uploadLoading(referer, type, file)
            if (referer === 'statusUploadPerfil') {
                this.setState({
                    fotoPerfilFile: file
                })
            } else {
                this.setState({
                    [referer === 'statusUploadRG' ? 'documentoFile' : 'comprovanteFile']: file, error: {}
                }, () => {
                    this.uploadFile(referer, file, type)
                })
            }
        }
        return false
    }

    onRemove = (referer, type) => () => {
        const ref = type === 1 ? 'documento' : 'comprovanteEndereco'
        if (!this.state[referer === 'statusUploadRG' ? 'documentoAlt' : 'comprovanteAlt']) {
            this.setState({
                [ref]: null
            })
        }
    }

    render() {
        const { user } = this.props
        const nivelVerificacao = user && user.nivelVerificacao ? user.nivelVerificacao : ''
        const permissions = nivelVerificacao ? nivelVerificacao.split('').map(d => d | 0) : []

        return (
            <div className="cardWrapper">
                <Container>
                    <Row>
                        <Col md={2} className="p-0" style={{ borderRight: '1px solid #F6F3FF' }}>
                            <SideBar permissao={user.permissao} />
                        </Col>
                        <Col md={7} className="divMeusDados pl-5">
                            <div>
                                <h5 className="tx-pink font-weight-bold text-left pt-0">Meus dados</h5>
                                <label className="labelValueData tx-gray">{user.nome}</label>
                            </div>
                            <Row className='mt-4'>
                                <Col md={4}>
                                    <div >
                                        <label className="tx-pink labelData">{user.tipoPessoa === 1 ? 'Data de Nascimento' : 'Data de criação da empresa'}</label><br />
                                        <label className="tx-gray labelData">{moment(user.nascimento, 'YYYY-MM-DD').format('DD/MM/YYYY')}</label>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div >
                                        <label className="tx-pink labelData">{user.tipoPessoa === 1 ? 'CPF' : 'CNPJ'}</label><br />
                                        <label className="tx-gray labelData">{user.tipoPessoa === 1 ? maskCpf(user.cpf || '') : maskCnpj(user.cpf || '')}</label>
                                    </div>
                                    <div className={`documentoWrapper mt-3 ${this.state.comprovanteAlt ? 'pb-1' : 'pb-5'}`}>
                                        {
                                            this.state.documentoAlt ? (
                                                permissions[1] ? (
                                                    ''
                                                ) : (
                                                    <div className="infoPerfil d-flex mt-3">
                                                        <Icon type="warning" theme="filled" className="mr-2" />
                                                        <label className="mb-0">Documento em processo de validação.</label>
                                                    </div>
                                                )
                                            ) : (
                                                <div className="infoPerfil d-flex mt-3" style={{ cursor: 'pointer' }}>
                                                    <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />
                                                    <button type="text" style={{ border: 'none', outline: 'none', backgroundColor: 'rgba(0, 0, 0, 0)' }}>{user.tipoPessoa === 1 ? (<label className="mb-0" style={{ cursor: 'pointer', textAlign: 'initial' }} onClick={this.openModalIdentificacao}>Por favor, clique aqui para enviar o seu <b>documento de identificação.</b></label>) : (<label Por className="mb-0" style={{ cursor: 'pointer', textAlign: 'initial' }} onClick={this.openModalIdentificacao}>Por favor, clique aqui para enviar o seu <b>contrato social.</b></label>)}</button>
                                                </div>
                                            )
                                        }
                                    </div>
                                </Col>
                                {user.tipoPessoa === 1 ?
                                    <Col md={4}>
                                        <div >
                                            <label className="tx-pink labelData">RG</label><br />
                                            <label className="tx-gray labelData">{user.rg || ''}</label>
                                        </div>
                                    </Col>
                                    : <Col md={4} />}

                                <Col md={12}>
                                    <div>
                                        <hr className='hrBottomGray' />
                                    </div>
                                </Col>
                            </Row>
                            <Row className='mt-2'>
                                <Col md={4}>
                                    <div >
                                        <label className="tx-pink labelData">Telefone/celular</label><br />
                                        <label className="tx-gray labelData">{maskTelefone(user.telefone || '')}</label>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div >
                                        <label className="tx-pink labelData">E-mail</label><br />
                                        <label className="tx-gray labelData">{user.email}</label>
                                    </div>
                                </Col>
                                <Col md={4} />

                                <Col md={12}>
                                    <div>
                                        <hr className='hrBottomGray' />
                                    </div>
                                </Col>
                            </Row>
                            <Row className='mt-2'>
                                <Col md={4}>
                                    <div >
                                        <label className="tx-pink labelData">Endereço</label><br />
                                        <label className="tx-gray labelData">{user.endereco}</label>
                                    </div>
                                    <div>
                                        <div className={`documentoWrapper mt-3 ${this.state.comprovanteAlt ? 'pb-2' : 'pb-5'}`}>
                                            {this.state.comprovanteAlt ? (
                                                permissions[0] ? (
                                                    ''
                                                ) : (
                                                    <div className="infoPerfil d-flex mt-3">
                                                        <Icon type="warning" theme="filled" className="mr-2" />
                                                        <label className="mb-0">Comprovante em processo de validação.</label>
                                                    </div>
                                                )
                                            ) : (
                                                <div className="infoPerfil d-flex mt-3" style={{ cursor: 'pointer' }}>
                                                    <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />
                                                    <button type="text" style={{ border: 'none', outline: 'none', backgroundColor: 'rgba(0, 0, 0, 0)' }}><label className="mb-0" style={{ cursor: 'pointer', textAlign: 'initial' }} onClick={this.openModalDocEndereco}>Por favor, clique aqui para enviar o seu <b>comprovante de residência.</b></label></button>
                                                </div>
                                            )
                                            }
                                        </div>
                                    </div>
                                </Col>
                                <Col md={2}>
                                    <div >
                                        <label className="tx-pink labelData">Número</label><br />
                                        <label className="tx-gray labelData">{user.numero}</label>
                                    </div>
                                </Col>
                                <Col md={2}>
                                    <div >
                                        <label className="tx-pink labelData">Complemento</label><br />
                                        <label className="tx-gray labelData">{user.complemento}</label>
                                    </div>
                                </Col>
                            </Row>
                            <Row className='mt-1'>
                                <Col md={4}>
                                    <div >
                                        <label className="tx-pink labelData">Cidade/Estado</label><br />
                                        <label className="tx-gray labelData">{user.cidade}</label>
                                    </div>


                                </Col>
                                <Col md={4}>
                                    <div >
                                        <label className="tx-pink labelData">CEP</label><br />
                                        <label className="tx-gray labelData">{user.cep}</label>
                                    </div>
                                </Col>
                            </Row>

                        </Col>

                        <Col md={3}>
                            <div>
                                {user.fotoPerfil === null || user.fotoPerfil === undefined || user.fotoPerfil === '' ?
                                    <div className="d-flex justify-content-center">
                                        <img src={profile} alt="Foto de perfil" className="fotoUser" />
                                    </div> :
                                    <div className="d-flex justify-content-center">
                                        <img src={user.url} alt="Foto de perfil" className="fotoUser" />
                                    </div>
                                }
                                <div className="infoPerfil d-flex mt-3">
                                    <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />
                                    <label className="mb-0">Adicione ou altere sua <b className="mb-0">foto de perfil.</b></label>
                                </div>
                                <div className="documentoWrapper mt-3 pb-5">
                                    <div className="pb-3">
                                        <Dragger
                                            beforeUpload={this.beforeUpload('statusUploadPerfil', 6)}
                                            onRemove={this.onRemove('statusUploadPerfil', 6)}
                                        >
                                            <label className="tx-pink mb-0"><img alt="Ícone upload" src={attach} className="img-fluid" />Clique ou arraste e solte o arquivo aqui</label>
                                        </Dragger>
                                        <Button
                                            className="btnAnexo"
                                            disabled={this.state.fotoPerfilFile == null ? true : false}
                                            onClick={this.uploadFile('statusUploadPerfil', this.state.fotoPerfilFile, 6)}
                                        >
                                            <Icon type={this.state.statusUploadPerfil === 'loading' ? 'loading' : 'upload'} /> Enviar Anexo
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>


                </Container>
                <Modal
                    title="Alterar minha senha"
                    visible={this.state.modalSenhaOpened}
                    onCancel={this.closeModalSenha}
                    footer={[
                        <Button key="cancel" onClick={this.closeModalSenha}>Fechar</Button>
                    ]}
                >
                    <FormResetPassword user={user} />
                </Modal>

                {this.state.modalOpenDocModal ? (
                    <Modal
                        classname="modalAporte"
                        title={'Envie seu documento aqui'}
                        visible={this.state.modalOpenDocModal}
                        onCancel={this.closeModalIdentificacao}
                        maskClosable = {false}
                        width={400}
                        footer={[
                            <Button key="cancel" onClick={this.closeModalIdentificacao}>Fechar</Button>
                        ]}
                    >
                        {this.state.statusUploadRG === 'done' ? (
                            <div className="finishedSignup">
                                <div>
                                    <h2 style={{ fontSize: '20px' }}>Documento enviado!</h2>
                                    <p>
                                        Sucesso! Seu documento foi enviado com sucesso! <br />
                                    </p>
                                </div>
                            </div>
                        ) : (
                            <div className="mt-3">{!this.state.documentoAlt ? (
                                <Dragger
                                    className={this.state.documentoAlt ? 'novisible' : ''}
                                    // disabled={!!this.state.documento}
                                    beforeUpload={this.beforeUpload('statusUploadRG', 1)}
                                    onRemove={this.onRemove('statusUploadRG', 1)}
                                >
                                    <label className="tx-pink mb-0"><img alt="Ícone upload" src={attach} className="img-fluid" />Clique ou arraste e solte o arquivo aqui</label>
                                </Dragger>
                            ) : ''}
                                <Icon style={{ fontSize: '25px', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '10px' }} type={this.state.statusUploadRG === 'loading' ? 'loading' : ''} />
                                {this.state.isClicked === 1 ?
                                    <>
                                        <br />
                                        <small style={{ color: 'red' }}>{this.state.error.type && this.state.error.type === 'specialChars' ? this.state.error.message : ''}</small>
                                        <small style={{ color: 'red' }}>{this.state.error.type && this.state.error.type === 'fileSize' ? this.state.error.message : ''}</small><br />
                                        <small style={{ color: 'red' }}>{this.state.error.type && this.state.error.type === 'typeOfFile' ? this.state.error.message : ''}</small><br />
                                    </> : ''
                                }

                            </div>
                        )}
                    </Modal>
                ) : ''}

                {this.state.modalOpenComprovante ? (
                    <Modal
                        classname="modalAporte"
                        title={'Envie seu comprovante aqui'}
                        visible={this.state.modalOpenComprovante}
                        onCancel={this.closeModalComprovante}
                        maskClosable = {false}
                        width={400}
                        footer={[
                            <Button key="cancel" onClick={this.closeModalComprovante}>Fechar</Button>
                        ]}
                    >
                        {this.state.statusUploadResidencia === 'done' ? (
                            <div className="finishedSignup">
                                <div>
                                    <h2 style={{ fontSize: '20px' }}>Comprovante enviado!</h2>
                                    <p>
                                        Sucesso! Seu comprovante foi enviado com sucesso! <br />
                                    </p>
                                </div>
                            </div>
                        ) : (
                                <div className={this.state.comprovanteAlt ? 'novisible' : 'mt-3 pb-3'}>
                                    {!this.state.comprovanteAlt ? (

                                        <Dragger
                                            disabled={!!this.state.comprovanteEndereco}
                                            beforeUpload={this.beforeUpload('statusUploadResidencia', 2)}
                                            onRemove={this.onRemove('statusUploadResidencia', 2)}
                                        >
                                            <label className="tx-pink mb-0"><img alt="Ícone upload" src={attach} className="img-fluid" />Clique ou arraste e solte o arquivo aqui</label>
                                        </Dragger>) : ''}
                                        <Icon style={{ fontSize: '25px', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '10px' }} type={this.state.statusUploadResidencia === 'loading' ? 'loading' : ''} />
                                    {this.state.isClicked === 2 ?
                                        <>
                                            <br />
                                            <small style={{ color: 'red' }}>{this.state.error.type === 'specialChars' ? this.state.error.message : ''}</small>
                                            <small style={{ color: 'red' }}>{this.state.error.type && this.state.error.type === 'fileSize' ? this.state.error.message : ''}</small><br />
                                            <small style={{ color: 'red' }}>{this.state.error.type === 'typeOfFile' ? this.state.error.message : ''}</small><br />
                                        </> : ''
                                    }
                                </div>
                        )}
                    </Modal>
                ) : ''}

            </div>
        )
    }
}

export default CardUserWrapper